import { Instance, types } from 'mobx-state-tree'

export const Recommendation = types.model('Recommendation', {
  attachmentType: types.maybeNull(types.enumeration(['locator', 'telescope', 'bridge'])),
  count: types.number,
  jawType: types.enumeration(['lower', 'upper']),
  recommendationType: types.enumeration(['crown', 'bridge', 'implant'])
})

export type RecommendationInstance = Instance<typeof Recommendation>
